export default __webpack_public_path__ + "static/media/Empresa2.bd969b87.png";